// extracted by mini-css-extract-plugin
export default {"wrapper":"-7Dz2Le0sd1+zwfcDsQGeQ=="};